export default{
    JobTypes: [{
        GroupName: '公共', Items: [
          { label: '确认运动员到场', value: '确认运动员到场' },
          { label: '设置弃权', value: '设置弃权' },
          { label: '判定违例', value: '判定违例' },
          { label: '成绩确认', value: '成绩确认' },
          { label: '扣分次数', value: '扣分次数' }]
      },
      {
        GroupName: '竞速赛', Items: [
          { label: '计次', value: '计次' },
          { label: '计数按钮', value: '计数按钮' },
        ]
      },
      {
        GroupName: '花样赛/集体自编赛', Items: [
          { label: '难度分D', value: '难度分D' },
          { label: '重复难度U', value: '重复难度U' },
          { label: 'Pa动作技能', value: 'Pa动作技能' },
          { label: 'Pr娱乐编排', value: 'Pr娱乐编排' },
          { label: 'Pr音乐运用', value: 'Pr音乐运用' },
          { label: 'Fs形式风格', value: 'Fs形式风格' },
          { label: '规定Q', value: '规定Q' },
          { label: 'Pa失误', value: 'Pa失误' },
          { label: 'Q失误', value: 'Q失误' },
          { label: 'Pa违例', value: 'Pa违例' }]
      },
      {
        GroupName: '精英级花样', Items: [
          { label: 'DP难度/重复难度', value: '【精英级花样】DP难度/重复难度' },
          { label: 'DM难度/重复难度', value: '【精英级花样】DM难度/重复难度' },
          { label: 'DR难度/重复难度', value: '【精英级花样】DR难度/重复难度' },
          { label: 'DA难度/重复难度', value: '【精英级花样】DA难度/重复难度' },
          { label: 'DB难度/重复难度', value: '【精英级花样】DB难度/重复难度' },
          { label: 'DJ难度', value: '【精英级花样】DJ难度' },
          { label: 'DT难度/重复难度', value: '【精英级花样】DT难度/重复难度' },
          { label: '表现P', value: '【精英级花样】表现P' },
          { label: '规定元素：力量体操', value: '【精英级花样】规定元素：力量体操' },
          { label: '规定元素：多摇', value: '【精英级花样】规定元素：多摇' },
          { label: '规定元素：绳子运用', value: '【精英级花样】规定元素：绳子运用' },
          { label: '规定元素：互相配合', value: '【精英级花样】规定元素：互相配合' },
          { label: '失误m', value: '【精英级花样】失误m' },
          { label: '间歇b', value: '【精英级花样】间歇b' },
          { label: '违例v', value: '【精英级花样】违例v' },
         ]   
      },
      {
        GroupName: '精英级表演赛', Items: [
          { label: 'DP难度/重复难度', value: '【精英级表演赛】DP难度/重复难度' },
          { label: 'DM难度/重复难度', value: '【精英级表演赛】DM难度/重复难度' },
          { label: 'DR难度/重复难度', value: '【精英级表演赛】DR难度/重复难度' },
          { label: 'DA难度/重复难度', value: '【精英级表演赛】DA难度/重复难度' },
          { label: 'DB难度/重复难度', value: '【精英级表演赛】DB难度/重复难度' },
          { label: 'DJ难度', value: '【精英级表演赛】DJ难度' },
          { label: 'DT难度/重复难度', value: '【精英级表演赛】DT难度/重复难度' },
          { label: 'DL难度/重复难度', value: '【精英级表演赛】DL难度/重复难度' },
          { label: '表现P', value: '【精英级表演赛】表现P' },
          { label: '规定元素', value: '【精英级表演赛】规定元素Q' },
          { label: '失误m', value: '【精英级表演赛】失误m' },
          // { label: '间歇b', value: '【精英级花样】间歇b' },
          { label: '违例v', value: '【精英级表演赛】违例v' },
         ]   
      },
      {
        GroupName: '规定赛/国内规定赛', Items: [
          { label: '创意编排分', value: '【规定赛】创意编排分' },
          { label: '完成质量分', value: '【规定赛】完成质量分' }]
      },
      {
        GroupName: '国内表演赛',
        Items: [
          { label: '一级难度', value: '【国内表演赛】一级难度' },
          { label: '二级难度', value: '【国内表演赛】二级难度' },
          { label: '三级难度', value: '【国内表演赛】三级难度' },
          { label: '重复一级难度', value: '【国内表演赛】重复一级难度' },
          { label: '重复二级难度', value: '【国内表演赛】重复二级难度' },
          { label: '重复三级难度', value: '【国内表演赛】重复三级难度' },
          { label: '创意编排分', value: '【国内表演赛】创意编排分' },
          { label: '规定元素分', value: '【国内表演赛】规定元素分' },
          { label: '完成质量分', value: '【国内表演赛】完成质量分' }]
      },
      {
        GroupName: '国内花样赛',
        Items: [
          { label: '一级难度', value: '【国内花样赛】一级难度' },
          { label: '二级难度', value: '【国内花样赛】二级难度' },
          { label: '三级难度', value: '【国内花样赛】三级难度' },
          { label: '重复一级难度', value: '【国内花样赛】重复一级难度' },
          { label: '重复二级难度', value: '【国内花样赛】重复二级难度' },
          { label: '重复三级难度', value: '【国内花样赛】重复三级难度' },
          { label: '规定元素：力量体操', value: '【国内花样赛】规定元素：力量体操' },
          { label: '规定元素：多摇', value: '【国内花样赛】规定元素：多摇' },
          { label: '规定元素：绳子运用', value: '【国内花样赛】规定元素：绳子运用' },
          { label: '规定元素：互相配合', value: '【国内花样赛】规定元素：互相配合' },
          { label: '创意编排', value: '【国内花样赛】创意编排分' },
          { label: '完成质量', value: '【国内花样赛】完成质量分' }]
      },
      {
        GroupName: '国内集体个人花样一级/国内集体个人花样二级',
        Items: [{ label: '一级难度', value: '【国内集体个人花样】一级难度' },
        { label: '二级难度', value: '【国内集体个人花样】二级难度' },
        { label: '重复一级难度', value: '【国内集体个人花样】重复一级难度' },
        { label: '重复二级难度', value: '【国内集体个人花样】重复二级难度' },]
      }
      ],
}